import { useNavigate } from 'react-router-dom'
import Header from '../components/Header'

export default function HowItWorks() {
const navigate = useNavigate()

return (
<div>
<Header />
<div className="container" style={{ padding: '1rem' }}>
<button className="btn btn-ghost btn-sm" onClick={() => navigate(-1)}>← Back</button>
</div>

{/* Hero — gradient blue/purple */}
<div style={{
background: 'var(--gradient-brand)',
padding: '4rem 1rem',
textAlign: 'center',
position: 'relative',
overflow: 'hidden',
marginTop: 12,
borderTopLeftRadius: 24,
borderTopRightRadius: 24,
}}>
<div style={{
position: 'absolute', inset: 0,
background: 'radial-gradient(circle at 80% 20%, rgba(255,255,255,0.15), transparent 50%)',
pointerEvents: 'none',
}} />
<div style={{ position: 'relative' }}>
<h1 style={{
color: '#fff',
fontFamily: "'Plus Jakarta Sans', sans-serif",
fontWeight: 800,
fontSize: 'clamp(28px, 5vw, 48px)',
marginBottom: 12,
letterSpacing: '-0.02em',
}}>
How HireIt works
</h1>
<p style={{ color: 'rgba(255,255,255,0.9)', fontSize: 18, maxWidth: 500, margin: '0 auto', lineHeight: 1.6 }}>
The easiest way to hire anything from people near you — or earn money from things sitting idle.
</p>
</div>
</div>

{/* For hirers */}
<div className="container" style={{ maxWidth: 800, padding: '4rem 1rem' }}>
<div style={{ textAlign: 'center', marginBottom: '3rem' }}>
<span className="badge badge-primary" style={{ fontSize: 14, padding: '6px 16px', marginBottom: 12 }}>For hirers</span>
<h2 style={{ fontSize: 28, fontWeight: 700, color: 'var(--navy)', marginTop: 12 }}>Need something? Hire it.</h2>
<p style={{ color: 'var(--text-muted)', marginTop: 8 }}>Save money by hiring instead of buying</p>
</div>
<div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(220px, 1fr))', gap: '1.5rem', marginBottom: '3rem' }}>
{[
{ step: '1', icon: '🔍', title: 'Search nearby', desc: 'Search by suburb, postcode or city. Filter by category and distance to find exactly what you need.' },
{ step: '2', icon: '📅', title: 'Book instantly', desc: 'Choose your hire period — hours, days or weeks. Send a booking request to the owner.' },
{ step: '3', icon: '🤝', title: 'Pick up & use', desc: 'Once confirmed, arrange collection with the owner. Return it when done. Simple!' },
{ step: '4', icon: '⭐', title: 'Leave a review', desc: 'After your hire, rate your experience. Reviews build trust for the whole community.' },
].map(s => (
<div key={s.step} style={{
background: '#fff',
borderRadius: 16,
padding: '1.5rem',
border: '1px solid var(--border)',
textAlign: 'center',
boxShadow: 'var(--shadow-sm)',
transition: 'transform 0.15s, box-shadow 0.15s',
}}>
<div style={{
width: 48,
height: 48,
borderRadius: '50%',
background: 'var(--gradient-brand)',
color: '#fff',
display: 'flex',
alignItems: 'center',
justifyContent: 'center',
fontWeight: 700,
fontSize: 18,
margin: '0 auto 12px',
boxShadow: '0 4px 12px rgba(45, 63, 204, 0.25)',
}}>{s.step}</div>
<div style={{ fontSize: 36, marginBottom: 8 }}>{s.icon}</div>
<div style={{ fontWeight: 700, marginBottom: 6, color: 'var(--navy)' }}>{s.title}</div>
<div style={{ fontSize: 14, color: 'var(--text-muted)', lineHeight: 1.6 }}>{s.desc}</div>
</div>
))}
</div>
<div style={{ textAlign: 'center' }}>
<button className="btn btn-gradient btn-lg" onClick={() => navigate('/')}>Browse listings →</button>
</div>
</div>

{/* For owners — pale blue background */}
<div style={{ background: 'var(--primary-pale)', padding: '4rem 1rem' }}>
<div className="container" style={{ maxWidth: 800 }}>
<div style={{ textAlign: 'center', marginBottom: '3rem' }}>
<span className="badge badge-accent" style={{ fontSize: 14, padding: '6px 16px', marginBottom: 12 }}>For owners</span>
<h2 style={{ fontSize: 28, fontWeight: 700, color: 'var(--navy)', marginTop: 12 }}>Earn from what you already own</h2>
<p style={{ color: 'var(--text-muted)', marginTop: 8 }}>Your items could be earning you money right now</p>
</div>
<div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(220px, 1fr))', gap: '1.5rem', marginBottom: '3rem' }}>
{[
{ step: '1', icon: '📸', title: 'List your item', desc: 'Take a few photos, set your price per hour, add a description. Takes less than 5 minutes.' },
{ step: '2', icon: '🔔', title: 'Get booking requests', desc: "Hirers send you booking requests. You accept or decline — you're always in control." },
{ step: '3', icon: '💰', title: 'Get paid', desc: 'Payments are processed securely via Stripe. Your earnings are paid directly to your bank.' },
{ step: '4', icon: '🔄', title: 'Repeat!', desc: 'The more you list, the more you can earn.' },
].map(s => (
<div key={s.step} style={{
background: '#fff',
borderRadius: 16,
padding: '1.5rem',
border: '1px solid var(--border)',
textAlign: 'center',
boxShadow: 'var(--shadow-sm)',
}}>
<div style={{
width: 48,
height: 48,
borderRadius: '50%',
background: 'var(--gradient-brand)',
color: '#fff',
display: 'flex',
alignItems: 'center',
justifyContent: 'center',
fontWeight: 700,
fontSize: 18,
margin: '0 auto 12px',
boxShadow: '0 4px 12px rgba(123, 63, 228, 0.25)',
}}>{s.step}</div>
<div style={{ fontSize: 36, marginBottom: 8 }}>{s.icon}</div>
<div style={{ fontWeight: 700, marginBottom: 6, color: 'var(--navy)' }}>{s.title}</div>
<div style={{ fontSize: 14, color: 'var(--text-muted)', lineHeight: 1.6 }}>{s.desc}</div>
</div>
))}
</div>
<div style={{ textAlign: 'center' }}>
<button className="btn btn-gradient btn-lg" onClick={() => navigate('/list-item')}>List an item →</button>
</div>
</div>
</div>

{/* FAQ */}
<div className="container" style={{ maxWidth: 700, padding: '4rem 1rem' }}>
<h2 style={{ fontSize: 28, fontWeight: 700, textAlign: 'center', marginBottom: '2rem', color: 'var(--navy)' }}>Common questions</h2>
<div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
{[
{ q: 'Is HireIt free to join?', a: 'Yes! Creating an account and listing items is completely free. HireIt charges a 12% service fee on completed hires, which is deducted automatically.' },
{ q: 'What counts as a qualifying hire for the launch offer?', a: "When you sign up and complete your first hire as an owner within 30 days of your signup date, you'll pay a reduced platform fee of 8% on that one hire — instead of the standard 12%. To qualify, the hire must be completed while you're acting as the owner/lister; hires you make as a hirer don't count. After your first qualifying hire completes, or once the 30-day window from your signup date passes — whichever comes first — the standard 12% fee applies to all future hires." },
{ q: 'How do payments work?', a: "All payments are processed securely via Stripe. When a booking is made the payment is authorised and held — it isn't taken until the hire is confirmed. Owners receive their payout, minus the 12% service fee, directly to their bank account." },
{ q: "What's the deposit?", a: "Security deposits are optional and set by the owner. Where one applies it's refundable and held during the hire rather than charged, so the only cost to the hirer is the hire fee itself. Plenty of listings have no deposit at all." },
{ q: 'What about insurance?', a: "HireIt doesn't provide or underwrite insurance. Both owners and hirers have the option to arrange their own cover independently. Integrated insurance protection is something we're working towards as the platform grows." },
{ q: 'What if something gets damaged?', a: "Owners can set a refundable security deposit, which gives a financial buffer if something goes wrong. Photos can be taken at pickup and return so there's a record of the item's condition either side of the hire, and owners can ask hirers to show their driver's licence at pickup if they choose. In the first instance issues are worked out between the owner and hirer directly, and HireIt can step in to help mediate if needed." },
{ q: 'Where does HireIt operate?', a: "HireIt is Australian-built and currently focused on Australia. Hires happen locally between people in the same area, so pickup and drop-off are nearby." },
{ q: 'Is HireIt available on Android?', a: "The Android app is in testing ahead of its Google Play release. In the meantime HireIt works from any phone browser at www.hireitnow.au. If you'd like early access to the Android app, get in touch and we'll add you to the tester list." },
{ q: "Can I request an item that isn't listed?", a: "Not yet. At the moment HireIt is browse-and-book — you search your area and see what's available nearby. A wanted feature, where you post what you're after and owners get notified, is on the roadmap." },
{ q: 'How do I contact the owner before booking?', a: 'You can message any owner directly through our in-app messaging system. Just click on a listing and use the Message the owner button.' },
].map(faq => (
<div key={faq.q} style={{
background: '#fff',
borderRadius: 12,
padding: '1.25rem',
border: '1px solid var(--border)',
borderLeft: '3px solid var(--primary)',
}}>
<div style={{ fontWeight: 700, marginBottom: 6, color: 'var(--navy)' }}>{faq.q}</div>
<div style={{ fontSize: 14, color: 'var(--text-muted)', lineHeight: 1.7 }}>{faq.a}</div>
</div>
))}
</div>
</div>

{/* Final CTA — gradient */}
<div style={{
background: 'var(--gradient-brand)',
padding: '4rem 1rem',
textAlign: 'center',
position: 'relative',
overflow: 'hidden',
}}>
<div style={{
position: 'absolute', inset: 0,
background: 'radial-gradient(circle at 20% 80%, rgba(255,255,255,0.15), transparent 50%)',
pointerEvents: 'none',
}} />
<div style={{ position: 'relative' }}>
<h2 style={{
color: '#fff',
fontFamily: "'Plus Jakarta Sans', sans-serif",
fontWeight: 800,
fontSize: 28,
marginBottom: 12,
letterSpacing: '-0.01em',
}}>Ready to get started?</h2>
<p style={{ color: 'rgba(255,255,255,0.9)', marginBottom: 24, fontSize: 16 }}>
Join others already hiring and earning on HireIt
</p>
<div style={{ display: 'flex', gap: 12, justifyContent: 'center', flexWrap: 'wrap' }}>
<button className="btn btn-white btn-lg" onClick={() => navigate('/')}>Browse listings</button>
<button className="btn btn-outline btn-lg" style={{ color: '#fff', borderColor: 'rgba(255,255,255,0.6)' }} onClick={() => navigate('/list-item')}>List an item</button>
</div>
</div>
</div>
</div>
)
}